// @vendors
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
const PropTypes = require('prop-types');

// @components
import { LoadingSection } from 'commonsComponents/loadingSection';

// @utilities
import Storage from 'utilities/storage';
import UrlHelper from 'utilities/urlHelper';

// @constants
import { RENEW_TOKEN } from 'constants/aggregator/psd2DecoupledFlowType';
import { PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { SELECTED_BANK } from 'constants/aggregator/localStorageKeys';

class AggregatorCredentialsUrlCallback extends Component {

    componentDidMount() {
        const psd2FlowType = Storage.localStorage.get(PSD2_FLOW_TYPE)
        const isRenewTokenFlow = [RENEW_TOKEN].includes(psd2FlowType)

        this.saveData();

        isRenewTokenFlow ?
            this.props.history.push('/myprofile/global/entities/renew-token') :
            this.props.history.push('/myprofile/global/entities/add/token')
    }

    saveData = () => {
        const url = window.location.href;
        const currentLocalStorage = Storage.localStorage.get(SELECTED_BANK) || {};

        const urlQueryParamsChunk = url.split("?")[1];
        const queryParams = UrlHelper.getQueryParams(urlQueryParamsChunk || '') || {};

        const newLocalStorage = {
            ...currentLocalStorage,
            code: queryParams.code,
            state: queryParams.state,
        };

        Storage.localStorage.set(SELECTED_BANK, newLocalStorage)
    }

    render() {
        return (<LoadingSection />)
    }
}

AggregatorCredentialsUrlCallback.propTypes = {
    history: PropTypes.object.isRequired,
}

export default withRouter(AggregatorCredentialsUrlCallback);
